var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('tab-main-view',{attrs:{"loader":_vm.loading,"config":_vm.config,"item":_vm.showItem,"fetch":_vm.fetch,"module":'people',"route":'people',"method":'patch',"item-id":this.$route.params.id}})}
var staticRenderFns = []

export { render, staticRenderFns }